import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { SubpageBanner, SectionHeader } from 'components';

const Banner = () => (
  <StaticQuery
    query={graphql`
      query {
        mainBannerImage: file(
          relativePath: { eq: "fpdc/workshop-fpdc-image.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1400) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <SubpageBanner
        backgroundColor={'gray-light'}
        image={data.mainBannerImage.childImageSharp.fluid}
        contentBackground={'violet'}
        additionalClass={'fpdc__banner'}
        alt={'Workshops'}
      >
        <SectionHeader
          size={'large'}
          color={'white'}
          lineColor={'black'}
          description={
            'Boldare helps companies at each stage of the product development cycle: from ideating with a prototype, testing a product with an MVP, to finding a product-market fit and finally, scaling.'
          }
          hiddenDescription={
            '<br />Our agile product design and software development teams will advise on the best strategy, build the product, test it with users, improve it, and pass on to you all their know-how so you can grow sustainably.<br /><br />We have built over 250 digital products for almost 90 public, non-profit and business organisations around the world. Our aim is always to take the product to market as quickly as possible and iteratively improve it until we achieve all business goals, fulfil market & user needs, and develop unique differentiators and features.'
          }
          descriptionColor={'white'}
          fixed
          additionalClass={'section-header__description--medium'}
        >
          Full Cycle Product
          <br />
          Development
        </SectionHeader>
      </SubpageBanner>
    )}
  />
);

export default Banner;
